import { getAudioEl, setAudioEl } from "../../../store/audioStore";
import { LayerData } from "./layerData.model";
import { ref } from "valtio";

export class AudioLayerData extends LayerData {

    source: string;

    constructor(data?: Partial<AudioLayerData>) {
        super(data);
        this.source = data?.source || "";
        this.type = data?.type || "audio";
        this.effects = []

        const cachedAudio = getAudioEl(this.id);
        if (!cachedAudio) {
            const audio = ref(new window.Audio())
            audio.src = this.source
            audio.crossOrigin = 'Anonymous';
            setAudioEl(this.id, audio)
        }


    }

}
